

import React, { Component } from 'react';
import { PieChart, Pie, Cell, Tooltip } from 'recharts';
import PageLoader from '../common/PageLoader';
import { each } from 'lodash';
import { imageBasePath } from '../../constants/staticData';

class CustomPieChart extends Component {
  render() {
    const colors = ['#4D83D2', '#00C49F', '#FFBB28'];
    const { jobDistributionChart, isLoading } = this.props
    const customJobDistributionChart = [];
    each (jobDistributionChart, (job) => {
      job.value = job.jobcount;
      customJobDistributionChart.push(job);
    });
    return (
      <div>
        <div className="col-md-4 mpad0 padLeft0">
          <div className= {jobDistributionChart && jobDistributionChart.length?"overview-card":"overview-card no-data"}>
            <a><h5> JOB DISTRIBUTION </h5></a>
            {isLoading
              ?
              <PageLoader/>
              :
              (jobDistributionChart && jobDistributionChart.length)
                ?
                (<div className="charts-holder pie-chart">
                  <PieChart width={150} height={150} onMouseEnter={this.onPieEnter} >
                    <Pie
                      dataKey={"value"}
                      data={customJobDistributionChart}
                      innerRadius={35}
                      fill="#8884d8"
                      nameKey="name">
                      {
                        customJobDistributionChart.map((entry, index) => <Cell key={index} fill={colors[index % colors.length]} />)
                      }

                    </Pie>
                    <Tooltip />
                  </PieChart>
                  <ul className="chart-label">
                    <li><span>Service</span></li>
                    <li><span>Wash</span></li>
                    <li><span>Repair</span></li>
                  </ul>
                </div>)
                :
                <div style={{textAlign: 'center'}} className="empty-data-text">
                  <img src={`${imageBasePath}/distribution-icon.png`} alt="Top Location not available"/>
                  <h4>You can see this once you start receiving Jobs </h4>
                </div>
            }
          </div>
        </div>

      </div>
    );
  }
}

export default CustomPieChart;



// WEBPACK FOOTER //
// ./src/components/Overview/CustomPieChart.jsx